// to get the value of field from metadata
export const getValueFromMetadata = (scope, field, metadata) => {
  const _scope = metadata?.find((item) => item.scope === scope);
  return _scope ? _scope.data[field] : "";
};
